import { render, staticRenderFns } from "./attribute-field-NUMERIC.vue?vue&type=template&id=31d6146b&"
import script from "./attribute-field-NUMERIC.vue?vue&type=script&lang=js&"
export * from "./attribute-field-NUMERIC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d6146b')) {
      api.createRecord('31d6146b', component.options)
    } else {
      api.reload('31d6146b', component.options)
    }
    module.hot.accept("./attribute-field-NUMERIC.vue?vue&type=template&id=31d6146b&", function () {
      api.rerender('31d6146b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/attribute-form-fields/attribute-field-NUMERIC.vue"
export default component.exports